import React, { useState } from "react";
import { TextField } from "@mui/material";
import Button from '@mui/material/Button';
import axios from 'axios';
import DataGridComponent from "./DataGridProComponent";

const DataGridBuscaComponent = (props: any) => {
  const [responseRows, setResponseRows] = useState<any>({});
  const [criterio, setCriterio] = useState<string>('');
  const [pageSize, setPageSize] = useState<number>(20);

  const atualizaListaBuscaCallBack: any = async (pageSize: number, pageNumber: number) => {
      setPageSize(pageSize);
      let response = await axios.get(`${props.apiBusca}?page=${pageNumber}&pageSize=${pageSize}&criterio=${criterio}`);
      setResponseRows(response);
  }
  
  const buscar = async () => {
    await atualizaListaBuscaCallBack(pageSize, 0);
  };

  return (
    <div>
      <span className="area-busca">
        <TextField
          id="outlined-basic"
          label="Busca"
          value={criterio}
          onChange={(e) => setCriterio(e.target.value)}
          variant="outlined"
          className="col-md-10 col-12"
          style={{ paddingRight: 10 }} />

        <Button
          onClick={buscar}
          variant="contained"
          className="col-md-2"
          style={{ marginTop: 10 }}
          size="large">
          Buscar
        </Button>
      </span>

      <DataGridComponent
        heightFix='200' 
        responseRows={responseRows}
        paginationSide='server'
        hideEdit={props.hideEdit}
        columns={props.columns}
        fieldId={props.fieldId}
        onEditAction={props.onEditAction}
        onDeleteAction={props.onDeleteAction}
        atualizaListaBuscaCallBack={atualizaListaBuscaCallBack} />
    </div>
  )
}

export default DataGridBuscaComponent;